import styled from '@emotion/styled';
import { Loading as LoadingBase } from '../components/Loading';
export const Loading = styled(LoadingBase)`
  height: 100vh;
`;
